/* eslint-disable import/no-anonymous-default-export */
import { LOCALES } from "../locales";

export default {
  [LOCALES.SPANISH]: {
    hello: 'Hola',
    managementTitle: 'GESTIÓN',
    informationTitle: 'INFORMACIÓN',

    paymentsTitle: 'PAGOS',
    myProfileTitle: 'Mi perfil',
    logOutTitle: 'Cerrar sesión',
    helpTitle: 'Ayuda',
    franchiseTitle: 'Mis puntos de venta',
    workersTitle: 'Mis trabajadores',
    productsTitle: 'Mis productos',
    operationsTitle: 'Operaciones',
    marketingTitle: 'Marketing',
    consolidatedTitle: 'CONSOLIDADOS',
    paymentMethodTitle: 'Mis métodos de pago',
    billingTitle: 'Mi historial de pago ',
    operationalReportsTitle: 'Informes operativos',
    salesBalanceTitle: "Reporte de ventas",
    usageIndicatiorsTitle: 'Indicadores de uso',
    franchiseNav: 'PUNTOS DE VENTA',
    franchiseTypeNav: 'TIPO DE NEGOCIO',
    invoiceSchemaNav: 'RESOLUCIONES DE FACTURACIÓN',
    createNewFranchise: 'Crear nuevo punto de venta',
    createNewWorker: 'Crear trabajador',
    createNewProduct: 'Crear nuevo producto',
    createNewInvoiceSchema: 'Crear resolución de facturación',
    createNewIngredient: 'Crear nuevo ingrediente',
    createProductCategory: 'Crear nueva categoría',
    createFranchiseType: 'Crear tipo de negocio',
    createNewCompany: 'Crear nueva compañía',
    createNewSupervisor: 'Crear nuevo supervisor',
    createService: 'Crear Servicio',
    createServiceCategory: 'Crear Categoría de Servicio',
    editWorker: 'Editar trabajador',
    editFranchise: 'Editar punto de venta',
    editIngredient: 'Editar ingrediente',
    editProductCategory: 'Editar categoría',
    editServiceCategory: 'Editar categoría de servicio',
    editFranchiseType: 'Editar tipo de negocio',
    reportsOperatives: 'Informes operativos',
    editSupervisor: 'Editar supervisor',
    stockTitle: "Stock",
    //Titles
    operatorTitle: 'Mis trabajadores',
    productTitle: 'Mis productos',
    preorderTitle: 'Productos reservados',
    templateTitle: 'Plantillas de Inventario',
    templateAddProductsTitle: 'Agregar productos a la plantilla',
    ingredientsTitle: 'Ingredientes',
    compositionTitle: 'Composición',
    businessDataTitle: 'Datos de tu negocio',
    userDataTitle: 'Datos de usuario',
    credentialsTitle: 'Establece tu contraseña',
    welcomeTitle: '¡Bienvenido!',
    companiesTitle: 'Compañías',
    supervisorsTtile: 'Supervisores',
    inventoryTitle: 'Gestión de inventarios',
    cashTitle: "Seguimiento de efectivo",
    movementsHistory: 'Histórico de movimientos',
    forceInventory: 'Forzar inventario',
    editProduct: 'Editar producto',
    editService: 'Editar servicio',
    saveServiceLbl: 'GUARDAR SERVICIO',
    editNewInvoiceSchema: 'Editar resolución de facturación',
    importFormantTitle: 'Importar formato de inventario inicial',
    errorsInFormtTitle: 'Errores importando el inventario inicial',
    reasonInventorySubTitle: 'Motivo',
    last_forced_movement: 'Última actualización forzada: ',
    allSales: 'Total entradas',
    allBuys: 'Total salidas',
    all: 'TOTAL',
    inventoryManager: 'GESTOR DE INVENTARIOS',
    createNewService: 'Crear nuevo servicio',
    //Alert Labels
    uptadedProductAlertLbl: '¡El producto fue actualizado!',
    uptadedServiceAlertLbl: '¡El servicio fue actualizado!',
    updateInventoryAlerLbl: '¡Inventario actualizado!',
    //Modal labels
    createdProductLbl: '¡Producto creado!',
    whatNowLbl: '¿Qué deseas hacer ahora?',
    createOtherProductLbl: 'CREAR OTRO PRODUCTO',
    setUpThisProduct: 'configurar este producto',
    closelbl: "CERRAR",
    //Navs
    productsNav: 'PRODUCTOS',
    ingredientsNav: 'INGREDIENTES',
    categoriesNav: 'CATEGORÍAS',
    scheduleNav: 'HORARIOS',
    //Form labels
    nameLbl: 'Nombre',
    descriptionLbl: 'Descripción',
    franchiseTypeLbl: 'Tipo de negocio',
    prefixLbl: 'Prefijo',
    cityLbl: 'Ciudad',
    countryLbl: 'País',
    immediateDeliveryLbl: 'Entrega inmediata',
    locationLbl: 'Ubicación',
    saveFranchiseLbl: 'GUARDAR PUNTO DE VENTA',
    cancelLbl: 'CANCELAR',
    saveTagLbl: 'GUARDAR ETIQUETA',
    createMassiveEInvoicelbl: 'GENERAR FACTURAS',
    createMassiveElectronicInvoicelbl: 'GENERAR FACTURAS CONSOLIDADAS',
    downloadLbl: 'DESCARGAR VISTA PREVIA',
    excludeBill: 'EXCLUIR FACTURAS',
    createServiceLbl: 'CREAR SERVICIO',


    typeOfRange: "Selecciona el tipo de rango a analizar",
    selectRangeDate: " Selecciona el rango de fechas que deseas",

    cashRegisterLbl: "Caja registradora",

    ivaModeLbl: "Tiene Iva",
    ipoModeLbl: "Tiene Ipoconsumo",
    fixIpoLbl: "Ipoconsumo Fijo",
    ivaPercentageLbl: "Porcentaje de Iva",
    internalCodeLbl: "Código interno",
    insumosNav: "Insumos",

    userLbl: 'Usuario',
    userTypelbl: "Tipo de usuario",
    clientNameLbl: 'Escribe el nombre del cliente',
    productLbl: 'Producto',
    reportDescriptLbl: 'Descripción del informe',
    fullNameLbl: 'Nombre y apellido',
    firstNameLbl: 'Nombre',
    lastNameLbl: 'Apellido',
    passwordLbl: 'Contraseña',
    repeatPasswordLbl: 'Repetir contraseña',
    changePasswordLbl: 'CAMBIAR CONTRASEÑA',
    actualPasswordLbl: 'Contraseña actual',
    newPasswordLbl: 'Nueva contraseña',
    repeatNewPasswordLbl: 'Repetir nueva contraseña',
    emailLbl: 'Correo electrónico',
    franchiseLbl: 'Punto de venta',
    addFranchiseLbl: 'Agregar punto de venta',
    reportToGenerate: 'Informe a generar',
    franchisesLbl: 'Puntos de venta',
    businessNameLbl: 'Nombre de tu negocio',
    phoneLbl: 'Teléfono',
    inventoryControlLbl: 'Controlable por inventario',
    customerVisibleLbl: 'Visible para clientes',
    quantityModeLbl: 'Precio por unidad de medida',
    categoryLbl: 'Categoría',
    barCodeLbl: 'Código de barras',
    sellPriceLbl: 'Precio de venta',
    skuLbl: 'SKU',
    quantityLbl: 'Candidad',
    ingredientLbl: 'Ingrediente',
    unityLbl: 'Unidad',
    saveIngredientLbl: 'GUARDAR INGREDIENTE',
    saveProductCategoryLbl: 'GUARDAR CATEGORÍA',
    saveServiceCategoryLbl: 'GUARDAR CATEGORÍA DE SERVICIO',
    logOutLbl: 'CERRAR SESIÓN',
    uploadInventoryLbl: 'SUBIR INVENTARIO INICIAL',
    tryagaibLbl: 'INTENTARLO DE NUEVO',
    unitLbl: 'Unidad',
    inventoryReversibleLbl: 'Reversible por inventario',
    ivaLbl: 'IVA',
    typeLbl: 'Tipo',
    priorityLbl: 'Prioridad',
    primaryColorLbl: 'Color primario',
    lightPrimaryColorLbl: 'Color primario claro',
    darkPrimaryColorLbl: 'Color primario oscuro',
    secondaryColorLbl: 'Color secundario',
    lightSecondaryColorLbl: 'Color secundario claro',
    darkSecondaryColorLbl: 'Color secundario oscuro',
    principalImageLbl: 'Imagen Principal',
    toolbarImageLbl: 'Imagen de barra de herramientas',
    receiptImageLbl: 'Imagen de factura',
    //Labels invoice schema
    nameComercialLbl: 'Nombre comercial',
    genericTaxLbl: 'Impuesto genérico',
    extraLbl: 'Extra',
    addressLbl: 'Dirección',
    numberLbl: 'Número',
    nitLbl: 'Nit',
    minValuelLbl: 'Valor mínimo',
    maxValueLbl: 'Valor máximo',
    initialValue: 'Valor inicial',
    initialDateLbl: 'Fecha de inicio',
    sinceLbl: 'Desde',
    toLbl: 'Hasta',
    finalDateLbl: 'Fecha de fin',
    choseeDateLbl: 'Seleccione una fecha',
    choseeRangeDateLbl: "Seleccione un rango de fechas",
    ciiuLbl: 'CIIU',
    aprovalDateLbl: 'Fecha de aprobación',
    isPayrollLbl: 'Es una plantilla',
    salesGoal: "Meta de ventas mensual",
    indicatorLbl: "Indicador a mostrar",
    specialPricelbl: "Precio especial",
    discountPricelbl: "Precio de descuento",
    discountActivelbl: "Descuento activado",
    buyPricelbl: "Precio de costo",
    visiblelbl: "Visible para usuarios",
    createOtherServiceLbl: "CREAR OTRO SERVICIO",
    returnToServicesLbl: "Regresar a servicios",
    createdServiceLbl: "¡Servicio creado!",


    //Company form
    timezoneLbl: 'Zona horaria',
    freedemoLbl: 'Inicia con demo gratis',
    managerAccountLbl: 'Manager account',
    facebookPageIdLbl: 'Facebook page id',
    instagramActorIdLbl: 'Instagram actor id',
    companyLbl: 'Compañía',
    //Inventory
    graphLbl: 'Gráfico',
    tableLbl: 'Tabla',
    returnedLbl: 'Devolución',
    transferLbl: 'Traslado',
    giftLbl: 'Cortesía',
    lostLbl: 'Perdida',
    otherLbl: 'Otro',
    commentaryLbl: 'Comentario',
    referenceNumberLbl: 'Numero de referencia',
    relateLbl: "Relacionar",

    //Buttons
    saveWorkerLbl: 'GUARDAR TRABAJADOR',
    saveProductLbl: 'GUARDAR PRODUCTO',
    createWorkerLbl: 'CREAR TRABAJADOR',
    createFranchiseLbl: 'CREAR PUNTO DE VENTA',
    createProductLbl: 'CREAR PRODUCTO',
    saveCompanyLbl: 'GUARDAR COMPAÑÍA',
    createSupervisorLbl: 'GUARDAR SUPERVISOR',
    saveSupervisorLbl: 'GUARDAR SUPERVISOR',
    loginBtn: 'INICIAR SESIÓN',
    addIngredientLbl: 'AGREGAR',
    saveFranchiseTypeLbl: 'GUARDAR TIPO DE NEGOCIO',

    createIngredientLbl: 'CREAR INGREDIENTE',
    createProductCategoryLbl: 'CREAR NUEVA CATEGORÍA',
    createFranchiseTypeLbl: 'CREAR TIPO DE NEGOCIO',
    changeImageLbl: 'CAMBIAR IMAGEN',
    acceptLbl: 'ACEPTAR',
    readyLbl: '¡LISTO!',

    createInvoiceSchemaLbl: 'CREAR RESOLUCIÓN',
    saveInvoiceSchemaLbl: 'GUARDAR RESOLUCIÓN',
    downloadReportLbl: 'DESCARGAR',
    newReportLbl: 'NUEVO INFORME',
    //Calendar
    janLbl: 'Enero',
    febLbl: 'Febrero',
    marLbl: 'Marzo',
    aprLbl: 'Abril',
    mayLbl: 'Mayo',
    junLbl: 'Junio',
    julLbl: 'Julio',
    augLbl: 'Agosto',
    sepLbl: 'Septiembre',
    octLbl: 'Octubre',
    novLbl: 'Noviembre',
    decLbl: 'Diciembre',

    mondayLbl: 'Lunes',
    tuesdayLbl: 'Martes',
    wednesdayLbl: 'Miércoles',
    thursdayLbl: 'Jueves',
    fridayLbl: 'Viernes',
    saturdayLbl: 'Sábado',
    sundayLbl: 'Domingo',
    //Form labels

    // Table Headers
    nameHeader: 'Nombre',
    dayHeader: 'Día',
    timeRangeHeader: 'Horario',
    productHeader: 'Producto',
    categoryHeader: 'Categoría',
    franchiseTypeHeader: 'Tipo de negocio',
    unitHeader: 'Unidad',
    actionsHeader: 'Acciones',
    financialmanagerHeader: 'Responsable económico',
    roleHeader: 'Rol',
    lastIssuanceRangeHeader: 'Último rango de emisión',
    accumulatedValueHeader: 'Acumulado desde última emisión',
    massiveEInvoiceTitle: "Consolidado masivo de facturas",
    customerEInvoiceTitle: "Generar factura consolidado para",
    typeHeader: 'Tipo',
    numberHeader: 'Número',
    idNumberHeader: 'Identificación',
    minValueHeader: 'Valor mínimo',
    maxValueHeader: 'Valor máximo',
    startValueHeader: 'Valor inicial',
    approvedDateHeader: 'Fecha aprobación',
    usernameHeader: 'Usuario',
    nameLastnameHeader: 'Nombre y apellido',
    emailHeader: 'Correo',
    companyHeader: 'Compañía',
    lastSessionHeader: 'Último inicio de sesión',
    lastMovementHeader: 'Último movimiento',
    currentQuantityHeader: 'Cantidad actual',
    addHeader: 'Añadir',
    skuHeader: 'SKU',
    dateHeader: 'Fecha',
    typeMovementHeader: 'Tipo de movimiento',
    quantityHeader: 'Cantidad',
    balanceQuantityHeader: 'Saldo cantidad',
    referenceHeader: 'Referencia',
    movementTypeHeader: 'Tipo de movimiento',
    valueHeader: 'Valor',
    cashAvailableHeader: 'Efectivo disponible',
    barcodeHeader: "Código de barras",
    newQuantityHeader: "Nueva Cantidad",
    currentSourceQuantityHeader: "Cantidad actual origen",
    currentDestinationQuantityHeader: "Cantidad actual destino",
    transferQauntityHeader: "Cantidad a trasladar",
    newQuantityDestinationHeader: "Nueva cantidad destino",
    newQuantitySourceHeader: "Nueva cantidad origen",
    salePoint: "Punto de venta",
    productsHeader: "Productos",
    statusHeader: "Estado",
    transactionValueHeader: "Valor",
    reservationsTabLabel: "Productos reservados",
    presalesTabLabel: "Detalle de preventas",
    noHeader: " ",
    noHeader2: " ",
    sourceSalePointHeader: "Punto de venta de origen",
    destinationSalePointHeader: "Punto de venta de destino",
    emptyHeader: " ",
    /**
     * Demo
     */
    gastronomicLbl: 'Gastronómico',
    storeLbl: 'Tienda',
    franchiseNameLbl: 'Escribe un nombre para tu local',
    startLbl: '¡EMPEZAR!',

    cityHeader: 'Ciudad',
    countryHeader: 'País',
    demoProgressHeader: 'Progreso de demo',
    stateHeader: 'Estado',

    // Descriptions
    invalidLinkDescription: 'Este enlace no es válido',
    welcomeDescription:
      'Ahora podrás disfrutar de los beneficios de la plataforma Kurúah, desde cualquier lugar. Ingresa a nuestra plataforma web, o descarga las aplicación desde Play Store o AppStore.',
    gastronomicDescription:
      'Restaurantes, bares, cafés, y en general negocios cuyo producto requiere una preparación previa',
    storeDescription:
      'Supermercados, ropa, accesorios, repuestos, y cualquier tipo de negocio que distribuya productos al detal',
    welcomeLbl: '¡Bienvenido,',
    kindBusinessLbl: '¿Qué tipo de negocio tienes?',
    allReadyLbl: '¡Todo listo!',
    operatorDescriptionDemo:
      "Para empezar a registrar tus ventas, ingresa desde la aplicación 'Kurúah' para Android (disponible en el Play Store) con el siguiente",
    usernameLbl: 'Username: ',
    passwordDemoLbl: 'Constraseña: ',
    supervisorDescriptionDemo:
      'Para ver las ventas reportadas, ingresa desde la aplicación "Kurúah" para Android (disponible en el Play Store) y iOS (disponible en el App Store) con el siguiente usuario (es el mismo que usas para ingresar a la plataforma web):',
    dragndropDescription:
      'Arrastra o suelta, o haga clic para seleccionar el formato de importación',

    //Dropdown menu
    importProductsTitle: "Importar formato de productos",
    errorsImportingFormat: "Errores improtanto el formato",
    uploadFormatLbl: "IMPORTAR FORMATO",
    updateProductsAlerLbl: "¡Productos creados!",


    /**
     * MARKET
     */

    salePointTypeTitle: "Tipos de negocio",
    salePointTypeNav: "TIPOS DE NEGOCIO",
    productCategorylbl: "Categorías de producto",
    createSalePointTypelbl: "CREAR TIPO DE NEGOCIO",
    editSalePointTypelbl: "Editar tipo de negocio",
    currentIconlbl: "Ícono actual",
    createSalePointTypeTitle: "Crear tipo de negocio",
    resumeSalePointTypeTitle: "Resumen de tipos de negocio - última semana",
    detailsTitle: "Detalles",
    bestProductTitle: "Producto más vendido",
    todaySalesTitle: "Ventas de hoy",
    lastWeekSalesTitle: "Ventas de la última semana",
    lastMonthSalesTitle: "Venta del último mes",
    saleDetailsTitle: "Detalle de venta",
    salePointTypelbl: "Tipo de negocio",
    analyzelbl: "ANALIZAR",
    saveSalePointTypelbl: "GUARDAR TIPO DE NEGOCIO",
    sptCreatedSuccess: "El tipo de negocio fue creado con éxito",
    sptUpdatedSuccess: "El tipo de negocio fue actualizado con éxito",
    addRelationSptSp: "Punto de venta asociado exitosamente",
    remodeRelationSptSp: "Punto de venta desasociado exitosamente",
    lastDaysSalesTitle: "Ventas de los últimos 7 días",
    organizationTitle: "Organizaciones",
    createNewOrganization: "Crear nueva organización",
    createOrganizationLbl: "CREAR ORGANIZACIÓN",
    editOrganization: "Editar organización",
    saveOrganizationLbl: "GUARDAR ORGANIZACIÓN",
    organizationLbl: "Organización",
    editSalePoint: "Editar punto de venta",
    editSalePointlbl: "GUARDAR PUNTO DE VENTA",
    actionlbl: "Acción",
    selectDate: "Fecha",
    salePointSelect: "Punto de venta",
    advanceInventorylbl: "Inventario anticipado",
    templatelbl: "Plantilla",
    modelbl: "Tipo de plantilla",
    destiantionSalePointLbl: "Punto de venta de destino",
    modeNormalViewInventorylbl: "Vista normal",
    modeForcedInventorylbl: "Actualización forzada",
    modeAddInventorylbl: "Adición de inventario",
    modeTransferlbl: "Traslado",
    saveChanges: "GUARDAR CAMBIOS",
    savebutton: "GUARDAR",
    transferbutton: "TRASLADAR",
    inventoryUpdated: "Inventario actualizado con éxito",
    walletsTitle: "Billeteras",
    eInvoiceTitle: "Facturación electrónica",
    preOrder: "Pedidos anticipados",
    services: "Mis servicios",
    tagsTitle: "Etiquetas",
    dashboardSalesTitle: "Dashboard ventas",
    dashboardRechargeTitle: "Dashboard recargas",
    specialPricesOnlbl: "Precios especiales Activados",
    specialPricesOflbl: "Precios especiales Desactivados",
    deleteProductLbl: "ELIMINAR PRODUCTO",
    deletedProductLbl: "¡Producto eliminado!",
    returnProductLbl: "Volver a productos",
    returnHomeLbl: "Volver a inicio",
    returnLbl: "VOLVER",
    checkLbl: "CONFIRMAR",
    deletedWorkertLbl: '¿Seguro quieres eliminar este trabajador?',
    deleteWorkerLbl: 'ELIMINAR TRABAJADOR',
    callToAction: '¿Qué deseas hacer ahora?',
    optionActionlbl: '¿Qué deseas hacer ahora?',
    specialPricesActivatedSuccess: "Los precios especiales fueron activados con éxito",
    specialPricesDisctivatedSuccess: "Los precios especiales fueron desactivados con éxito",
    eInvoiceSucces: "Factura electrónica emitida",
    salesExcludedSuccess: "Las ventas fueron excluidas con éxito",
    templateCreatedSuccess: "La plantilla fue creada con éxito",
    traslateCreatedSuccess: "El traslado fue realizado con éxito",
    createTemplateTitle: 'Crear nueva plantilla',
    loadTemplateTitle: 'Cargar plantilla',
    editTemplateTitle: 'Editar plantilla',
    negativeProductsLbl: 'No se permiten valores inferiores a 0',
    notEnoughProductsLbl: 'No existen unidades suficientes en el punto de origen',
    traslatePerishableSuccess: "El traslado de perecederos fue realizado con éxito",
    templateEditedSuccess: "La plantilla fue editada con éxito",
    
    // Services translations
    servicesNav: "Servicios",
    serviceCategoriesNav: "categorías",
    serviceUpdatedSuccess: "El servicio fue actualizado con éxito",
    serviceActivatedSuccess: "La configuración de servicios fue activada con éxito",
    serviceDisactivatedSuccess: "La configuración de servicios fue desactivada con éxito",
  }
};
